import { CREATE_SESSION } from '../constants/Misc'

export default (state = null, action) => {
  switch (action.type) {
    case CREATE_SESSION:
      return { jwt: action.jwt }

    default:
      return state
  }
}

export const sessionTokenSelector = state => state.session && state.session.jwt
export const userSignedInSelector = state => Boolean(state.session)
